import { Component } from '@angular/core'
import { Router, ActivatedRoute} from '@angular/router'
import { BaseComponent } from '../components/base.component'
import { fullDayWithYear, planChangeSummaryPath } from '../utils'
import { xsrfToken } from '../request'
import { CustomerActions } from 'src/actions/customer-actions'
import { VideoPlanFormOutput } from 'src/modules/plan-form/video-plan-form.component'

@Component({
  selector: 'plan-page',
  template: `
    <multipass-plan-form *ngIf="showForm() && !video()"
               [customerId]="customerId"
               (onCreate)="navigateToDeliveryOptionsPage()">
    </multipass-plan-form>
    <ng-template [ngIf]="video()">
      <h3 class="h3-subheader text-center mt-5">How many videos do you want per month?</h3>
      <video-plan-form *ngIf="showForm()"
                      [customerId]="customer?.id" [plans]="plans" [quantity]="customer?.subscription?.quantity"
                      [buttonText]="'Change my plan'" [learnMore]="false"
                      (submit)="previewPlanChange($event)">
      </video-plan-form>
    </ng-template>
  `,
})
export class MultipassPlanPage extends BaseComponent {
  customerId: number

  constructor(private route: ActivatedRoute,
              private router: Router,
              private customerActions: CustomerActions,
              ) {
    super()
  }

  ngOnInit(): void {
    const routeObs = this.route.parent.params.subscribe(params => {
      this.customerId = +params['customerId']
    })
  }

  showForm(): boolean {
    return this.customerId != null
  }

  video(): boolean {
    return false
  }

  navigateToTopicsPage(): void {
    this.router.navigate(['/dashboard', this.customerId, 'topics'])
  }

  navigateToDeliveryOptionsPage(): void {
    this.router.navigate(['/dashboard', this.customerId, 'delivery_options'])
  }

  previewPlanChange(videoPlanOutput: VideoPlanFormOutput): void {
    const path = planChangeSummaryPath(videoPlanOutput)
    window.location.assign(path)
  }

  fullDayWithYear = fullDayWithYear;
  xsrfToken = xsrfToken;
}
